import { observer } from 'mobx-react-lite'
import Page404Component from './component'

const Page404: React.FC = (): React.ReactElement => {
	return <Page404Component />
}
export default observer(Page404)
